<template>
    <div>
        <v-layout wrap>
      <v-flex xs12 >
        <v-card outlined elevation="0" class="pa-4" data-aos="fade-up"
     data-aos-duration="1200">
     <v-flex xs12>Voters per caste</v-flex>
     <v-flex xs12 v-if="flag" class="mainfont">
                                    <div
                                      id="vuechart-example2"
                                      v-if="barlist.length > 0"
                                      class="mainfont"
                                    >
                                      <apexchart
                                        height="430"
                                        class="mainfont"
                                        type="bar"
                                        :options="chartOptions6"
                                        :series="series6"
                                      ></apexchart></div
                                  ></v-flex>
        </v-card>
      </v-flex>
    </v-layout>
    </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      barlist: [],

      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
// GRAPH
series6: [
        {
          name: "Voters",
          data: [],
        },
       
      ],
          chartOptions6: {
        colors: ["#29807C", "#00FFFF"],
        chart: {
          type: "bar",
          height: 430,
          width: "100%",
          id: "vuechart-example2",
          background: "#ffff",
        },
        plotOptions: {
          bar: {
            columnWidth: "80%",
            horizontal: false,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: false,
          offsetX: -1,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        fill: {
          colors: ["#29807C", "#00FFFF"],
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
              fontWeight: "bold",
              fontFamily: "mainfont",
              color: "#333",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "mainfont",
              color: "#333",
            },
          },
        },
        grid: {
          showLines: true,
        },
        legend: {
          fontSize: "12px",
          fontFamily: "mainfont",
          textColor: "#555",
          position: "top",
          horizontalAlign: "center",
        },
        series: [
          {
            name: "Series 1",
            data: [],
          },
          {
            name: "Series 2",
            data: [],
          },
        ],
      },
//
CountList:[],
adddialog:false,
adddialog2:false,
newName:"",
flag:false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
 
    mounted() {
      this.getCount();
    },
    methods: {
      getCount() {
      this.appLoading = true;
      axios({
        url: "/candidate/dashboard/count",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        // params: {
        //   page: this.page,
        //   limit: 50,

        // },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.barlist = response.data.data.casteData;
            // this.totalAuctionPrice = response.data.totalAuctionPrice;
            this.chartOptions6.xaxis.categories = [];
            const maxCount = [];

            for (let i = 0; i < this.barlist.length; i++) {
              this.chartOptions6.xaxis.categories.push(
                this.barlist[i].name
              );
              maxCount.push(this.barlist[i].count);
            }

            this.series6 = [
              { name: "Voters", data: maxCount },
            ];

            this.flag = true;
          } else {
              this.showsnackbar = true;
              this.msg = response.data.msg;
            }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    },
};
</script>
<style scoped>
.bluegrad{
  background: rgb(24,36,68);
background: linear-gradient(36deg, rgba(24,36,68,1) 3%, rgba(0,85,135,1) 52%, rgba(0,99,161,1) 95%);
}
</style>
